import React from 'react';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { Link } from 'react-router-dom';

export default function ListItemLink({ icon, primary, to, classes, disabled, onClick }) {
  const renderLink = React.forwardRef((props, ref) => (<Link ref={ref} to={to} {...props} />))
  return (
    <li>
      <ListItemButton dense component={renderLink} onClick={() => { onClick(); }} className={classes} disabled={disabled}>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={primary} />
      </ListItemButton>
    </li>
  );
}

